import React from 'react';

interface TeAmoPageProps {
  isDark: boolean;
}

const TeAmoPage: React.FC<TeAmoPageProps> = ({ isDark }) => {
  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className={`text-5xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Hola mi reina hermosa..
        </h1>
        <p className={isDark ? 'text-gray-300' : 'text-gray-600'}>
          Content goes here...
        </p>
      </div>
    </div>
  );
};

export default TeAmoPage;